export class FitUtil {
  static generateHeader(title, desc, ogImg) {
    return {
      title: {
        inner: title
      },
      meta: [
        { property: 'og:url', content: 'https://web-fit.work/' },
        { name: 'application-name', content: title },
        { itemprop: 'name', content: title },
        { property: 'og:title', content: title },
        { property: 'og:description', content: desc },
        { name: 'description', content: desc, id: 'desc' }, // id to replace intead of create element
        { itemprop: 'description', content: desc },
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: title },
        { name: 'twitter:description', content: desc},
        { name: 'og:image', property: 'og:image', content: ogImg },
        { name: 'twitter:image', property: 'twitter:image', content: ogImg },
      ],
      link: [
        // { rel: 'preconnect', href: 'https://fonts.googleapis.com' },
        // { rel: 'preconnect', href: 'https://fonts.gstatic.com' },
        // { rel: 'stylesheet', href: 'https://fonts.googleapis.com/icon?family=Material+Icons' },
      ],
    }
  }

  static isiOS() {
    return /iPhone|iPad|iPod/i.test(navigator.userAgent);
  }

  static isSafari() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
  }

  static isFirefox() {
    const browser = navigator.userAgent.toLowerCase();
    return browser.indexOf('firefox') > -1
  }

  static isAndroid() {
    return /Android/i.test(navigator.userAgent);
  }

  static isMobile() {
    return FitUtil.isAndroid() || FitUtil.isiOS();
  }
}



// WEBPACK FOOTER //
// ./src/components/common/FitUtil.js